if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/core.production.min.js")
} else {
  module.exports = require("./cjs/core.development.js")
}



//////////////////
// WEBPACK FOOTER
// ./~/@lingui/core/index.js
// module id = mbfA
// module chunks = 0